import { render, staticRenderFns } from "./AvailabilityWeek.vue?vue&type=template&id=521f9640&scoped=true"
import script from "./AvailabilityWeek.vue?vue&type=script&lang=js"
export * from "./AvailabilityWeek.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityWeek.vue?vue&type=style&index=0&id=521f9640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f9640",
  null
  
)

export default component.exports